import React from 'react';
import { useAITTheme } from '../ui/theme';

const BulletTrainIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={theme.tokens.colors.brand.primary}
        d="M20 8.62244C20 7.83585 19.6455 7.10571 19.0276 6.61926L17.5 5.41672V5.41657L11.8422 0.962525C11.0538 0.341797 10.067 0 9.06357 0H0V11.1719H17.4506C18.8564 11.1719 20 10.0282 20 8.62244ZM15.6055 5.41672H10.1692V4.08859H13.9185L15.6055 5.41672ZM8.99734 2.91672V6.58859H17.0941L18.3028 7.54013C18.6366 7.80304 18.8281 8.19748 18.8281 8.62244C18.8281 9.38202 18.2101 10 17.4506 10H1.17188V6.58859H6.83594V2.91672H1.17188V1.17188H9.06357C9.80515 1.17188 10.5347 1.42456 11.1174 1.88339L12.43 2.91672H8.99734ZM1.17188 4.08859H5.66406V5.41672H1.17188V4.08859Z"
      />
      <path fill={theme.tokens.colors.brand.primary} d="M0 12.5H20V13.6719H0V12.5Z" />
    </svg>
  );
};

export default BulletTrainIcon;
